<template>
  <div>
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <el-time-select
      v-model="currentValue.startTime"
      :value-format="timeFormat"
      :readonly="readonly"
      :disabled="disabled"
      :required="required"
      :picker-options="Object.assign(defaultPickerOptions, pickerOptions)"
      @input="handleStartTimeInput"
    >
    </el-time-select>
    <el-time-select
      v-model="currentValue.endTime"
      :value-format="timeFormat"
      :readonly="readonly"
      :disabled="disabled"
      :required="required"
      :picker-options="Object.assign(defaultPickerOptions, pickerOptions)"
      @input="handleEndTimeInput"
    >
    </el-time-select>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    value: {
      default() {
        return {};
      },
      type: [Object]
    },
    readonly: Boolean,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: true
    },
    pickerOptions: Object,
    format: String
  },
  data() {
    return {
      currentValue: this.value,
      defaultPickerOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:59'
      }
    };
  },
  computed: {
    timeFormat() {
      return this.format || this.$store.getters['timeFormat'];
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  methods: {
    copyValues() {
      if (!this.value) {
        return {};
      }
      return Object.keys(this.value).reduce((newValues, key) => {
        newValues[key] = this.value[key];
        return newValues;
      }, {});
    },
    handleStartTimeInput(startTime) {
      const timeRange = {
        ...this.copyValues(),
        startTime: startTime
      };
      this.$emit('input', timeRange);
    },
    handleEndTimeInput(endTime) {
      const timeRange = {
        ...this.copyValues(),
        endTime: endTime
      };
      this.$emit('input', timeRange);
    }
  }
};
</script>
